import moment from 'moment'

export const formatMeetings = (meetings) => {
  let colorTmp
  return meetings.map((meeting) => {
    if (meeting.user === null || typeof (meeting.user) === 'undefined' || meeting.user === 'undefined') {
      colorTmp = '#000000'
    } else {
      colorTmp = meeting.user.color
    }
    return {
      id: meeting.id,
      title: meeting.title,
      description: meeting.description,
      intervenantexterieur: meeting.intervenantexterieur,
      convention: meeting.convention,
      synthese: meeting.synthese,
      observations: meeting.observations,
      all_day: meeting.all_day,
      recurring: meeting.recurring,
      rdvindividuel: meeting.rdvindividuel,
      rdvcollectif: meeting.rdvcollectif,
      start: meeting.start,
      end: meeting.end,
      slotDuration: '00:15:00',
      backgroundColor: colorTmp,
      duration: meeting.duration,
      projectname: meeting.projectname
    }
  })
}

export const formatMeetingsWithUrl = (meetingsPlanning) => {
  let colorTmp
  return meetingsPlanning.map((meeting) => {
    // console.log('formatMeetingsWithUrl ' + meeting.id + ' ' + meeting.start + ' : ' + meeting.title)
    // if (meeting.user === null || meeting.user.color === null || typeof (meeting.user) === 'undefined' || typeof (meeting.user.color) === 'undefined' || meeting.user === 'undefined' || meeting.user.color === 'undefined' || meeting.user === '' || meeting.user.color === '') {
    if (typeof meeting.user === 'undefined' || meeting.user === 'undefined' || meeting.user === null) {
      console.log('color 000000')
      colorTmp = '#000000'
    } else {
      colorTmp = meeting.user.color
    }
    return {
      // url: '/#!/edit/' + meeting.id,
      id: meeting.id,
      title: meeting.title,
      description: meeting.description,
      intervenantexterieur: meeting.intervenantexterieur,
      convention: meeting.convention,
      synthese: meeting.synthese,
      observations: meeting.observations,
      all_day: meeting.all_day,
      recurring: meeting.recurring,
      rdvindividuel: meeting.rdvindividuel,
      rdvcollectif: meeting.rdvcollectif,
      start: meeting.start,
      end: meeting.end,
      slotDuration: '00:15:00',
      backgroundColor: colorTmp,
      duration:	meeting.duration,
      projectname: meeting.projectname
    }
  })
}

export const formatMeetingForForm = (meeting) => {
  let start = moment(meeting.start, 'YYYY-MM-DD HH:mm:ss')

  let startHour = start.format('HH')
  let startMinutes = start.format('mm')

  let end = moment(meeting.end, 'YYYY-MM-DD HH:mm:ss')

  let endHour = end.format('HH')
  let endMinutes = end.format('mm')

  return {
    // userId: meeting.user.id,
    userId: meeting.firstintervenant_id,
    placeId: meeting.place_id,
    firstintervenantId: meeting.firstintervenant_id,
    secondintervenantId: meeting.secondintervenant_id,
    thirdintervenantId: meeting.thirdintervenant_id,
    presenceId: meeting.presence_id,
    phaseId: meeting.phase_id,
    contentId: meeting.content_id,
    trainingId: meeting.training_id,
    // non present dans la mutation contentId: meeting.content_id,
    contactId: meeting.contact_id,
    projectId: meeting.project_id,
    title: meeting.title,
    description: meeting.description,
    intervenantexterieur: meeting.intervenantexterieur,
    convention: meeting.convention,
    synthese: meeting.synthese,
    observations: meeting.observations,
    all_day: !!meeting.all_day,
    recurring: !!meeting.recurring,
    rdvindividuel: !!meeting.rdvindividuel,
    rdvcollectif: !!meeting.rdvcollectif,
    day: start.format('DD-MM-YYYY'),
    endHour,
    endMinutes,
    startHour,
    startMinutes,
    duration:	meeting.duration,
    projectname: meeting.projectname
  }
}

export const formatMeetingForDBInsertion = (meeting) => {
  let startDate = moment(`${meeting.day} ${meeting.startHour} ${meeting.startMinutes}`, 'DD-MM-YYYY HH mm').format('YYYY-MM-DD HH:mm:ss')
  let endDate = moment(`${meeting.day} ${meeting.endHour} ${meeting.endMinutes}`, 'DD-MM-YYYY HH mm').format('YYYY-MM-DD HH:mm:ss')

  return {
    title: meeting.title,
    description: meeting.description,
    intervenantexterieur: meeting.intervenantexterieur,
    presence_id: meeting.presenceId,
    phase_id: meeting.phaseId,
    content_id: meeting.contentId,
    training_id: meeting.trainingId,
    place_id: meeting.placeId,
    firstintervenant_id: meeting.firstintervenantId,
    secondintervenant_id: meeting.secondintervenantId,
    thirdintervenant_id: meeting.thirdintervenantId,
    convention: meeting.convention,
    synthese: meeting.synthese,
    observations: meeting.observations,
    start: startDate,
    end: endDate,
    all_day: !!meeting.all_day,
    recurring: !!meeting.recurring,
    rdvindividuel: !!meeting.rdvindividuel,
    rdvcollectif: !!meeting.rdvcollectif,
    // user_id: meeting.userId,
    user_id: meeting.firstintervenantId,
    contact_id: meeting.contactId,
    project_id: meeting.projectId,
    duration:	meeting.duration,
    projectname: meeting.projectname
  }
}



// WEBPACK FOOTER //
// ./src/utils/fullcalendar.js